/* eslint-disable react-hooks/exhaustive-deps */
import { Form } from "antd";
import { useState } from "react";
import { UNIT_OF_MEASURE_TYPE } from "../../AppForm/constants";
import { AppPartType } from "../../AppForm/types";
import { getConfigAppPartType } from "../../utils";
import { Styles } from "./styled";
import InputNumberFormField from "@lhd/components/InputNumberFormField";
import { formatDecimal } from "@lhd/utility";

interface IProps {
  nameItem: string;
  item: AppPartType;
  parentItem?: AppPartType;
  isDisable?: boolean;
  isTable?: boolean;
  preview?: boolean;
  onChange?: (value: any | null) => void;
  styleColor?: React.CSSProperties;
  className?: string;
}

const InputNumber = (props: IProps) => {
  const {
    nameItem,
    item,
    onChange,
    isDisable,
    isTable,
    preview,
    styleColor = {},
    className,
  } = props;
  const form = Form.useFormInstance();
  const [shouldShowUnit, setShouldShowUnit] = useState(false);

  const { isHiddenLabel, labelText, maxChar, minChar } =
    getConfigAppPartType(item);

  const isUseThousandsSeparators = item.is_use_thousands_separators;
  const numberOfDecimalPlace = item.number_of_decimal_place;

  const addonBefore =
    item.unit_of_measure_type === UNIT_OF_MEASURE_TYPE.frefix ||
    item.unit_of_measure_type === UNIT_OF_MEASURE_TYPE.frefix_suffix
      ? item.unit_of_measure
      : "";

  const addonAfter =
    item.unit_of_measure_type === UNIT_OF_MEASURE_TYPE.suffix ||
    !item.unit_of_measure_type ||
    item.unit_of_measure_type === UNIT_OF_MEASURE_TYPE.frefix_suffix
      ? item.unit_of_measure
      : "";

  const value = form.getFieldValue(nameItem);
  const isShowOnlyValue = !preview && isTable && isDisable;
  return (
    <Styles className={!shouldShowUnit ? `should_hidden_unit` : ""}>
      {isShowOnlyValue && value && (
        <div className="value_text_container">
          {addonBefore}
          {formatDecimal(
            value,
            !!isUseThousandsSeparators,
            numberOfDecimalPlace,
          )}
          {addonAfter}
        </div>
      )}
      <InputNumberFormField
        isFormat={isUseThousandsSeparators}
        numberOfDecimalPlace={numberOfDecimalPlace}
        hidden={isShowOnlyValue}
        minChar={minChar}
        maxChar={maxChar}
        label={
          isHiddenLabel ? (
            ""
          ) : (
            <div className="no-wrap-text" title={labelText}>
              {labelText}
            </div>
          )
        }
        name={nameItem}
        rules={[
          {
            required: item.is_required_field,
            message: `必須項目です`,
          },
        ]}
        className={className}
        inputProps={{
          className: "align-right",
          addonBefore: addonBefore,
          addonAfter: addonAfter,
          size: "large",
          style: styleColor,
          onChange,
        }}
      />
    </Styles>
  );
};

export default InputNumber;
